import {
  Datagrid,
  DateField,
  EmailField,
  FunctionField,
  List,
  ReferenceField,
  TextField,
} from 'react-admin';
import { AdminGrantButton } from './AdminGrantButton';

export const AdminsList = () => (
  <List>
    <Datagrid bulkActionButtons={false}>
      <TextField label="ID" source="id" />
      <TextField label="Name" source="name" />
      <EmailField label="Email" source="email" />
      <DateField
        showTime
        label="Admin Grant Date"
        source="adminGrantedAt"
      />
      <ReferenceField
        label="Admin Granter"
        source="adminGrantedBy"
        reference="userMetadata"
      >
        <TextField source="name" />
      </ReferenceField>
      <FunctionField
        label="Admin Status"
        render={(record: any) => <AdminGrantButton record={record} />}
      />
      <DateField
        showTime
        label="Last Admin Update"
        source="lastUpdatedAt"
      />
    </Datagrid>
  </List>
);
